import { Checkbox as MuiCheckbox, FormGroup, FormLabel, FormControlLabel, FormControl, FormHelperText } from '@mui/material';
import { BuyerOptionProps, isGroupBuyerOptionValues } from '.';

import React, { useState } from 'react';
import LinkifyText from '../../common/LinkifyText';

export default function Checkbox(props: BuyerOptionProps) {
  const checkboxOptionVals = isGroupBuyerOptionValues(props.value) ? props.value : undefined;
  const vals = checkboxOptionVals ? checkboxOptionVals.options : [''];

  const [selectedValues, setSelectedValues] = useState<string[]>(
    props.currentValue ? props.currentValue.split(',').filter(Boolean) : []
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    const next = checked
      ? [...selectedValues, value]
      : selectedValues.filter(v => v !== value);

    setSelectedValues(next);

    if (props.onDetailChange) {
      props.onDetailChange(
        props.optionKey,
        next.join(','),
        props.isEditMode ? props.buyerDetailId : props.id
      );
    }
  };

  return (
    <FormControl required={props.isRequired} disabled={props.isDisabled} component="fieldset">
      <FormLabel sx={{ pb: 1 }}>
        <LinkifyText text={props.label} />
      </FormLabel>
      <FormGroup>
        {vals.map(value => (
          <FormControlLabel
            key={value}
            control={
              <MuiCheckbox
                value={value}
                checked={selectedValues.includes(value)}
                onChange={handleChange}
                disabled={props.isDisabled}
              />
            }
            label={<LinkifyText text={value} />}
          />
        ))}
      </FormGroup>
      {props.description && (
        <FormHelperText>
          <LinkifyText text={props.description} />
        </FormHelperText>
      )}
    </FormControl>
  );
}